<template>
  <div>
    <b-card
      border-variant="success"
      class="order-card-border"
      style="min-height: 9rem;"
    >
      <b-card-text>
        <b-row>
          <b-col cols="12" class="text-center">
            <i :class="`${icon} iconSize`"></i>
            <img v-if="icon == 'img-contrucoin'" src="@/assets/img/coin-logo.png" class="imgSize" alt="Constru Coin">
          </b-col>
        </b-row>
        <b-row class="text-center fontSize">
          <div :class="icon == 'img-contrucoin' ? 'textImg' : ''">{{ text }} </div>
        </b-row>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'ConstruCoinInfoCard ',
  props: {
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
  },
};
</script>

<style scoped>
.order-card-border {
  border-width: 0.5px !important;
  border-radius: 20px;
  border-color: orange !important;
}
.iconSize {
  font-size: 2.5rem;
  text-align: center;
}
.imgSize{
  width: 65px;
  margin-top: -40px;
}
.fontSize{
  font-size: 15.5px;
}
.textImg{
  margin-top: -15px;
}
</style>
